import React, { useEffect } from 'react'
import { Grid } from '@material-ui/core';
import { Buscador } from '../../../afiliaciones/Buscador';
import { AfiliadoTurno } from '../../../turnos/nuevo/AfiliadoTurno';
import { useSelector, useDispatch } from 'react-redux';
import { getAutopercepcionPorAfiliado } from '../../../../actions/turnos/agenda';

export const AutoPercepcion = () => {
    const dispatch = useDispatch();
    const { seleccionado, afiliado } = useSelector((state) => state.afiliacion);

    useEffect(() => {
        if (afiliado && afiliado.id_afiliado) {
          dispatch( getAutopercepcionPorAfiliado(afiliado.id_afiliado) );
        }
      }, [afiliado]);

    return (
        <Grid container 
            direction="row"
            justify="center"
            alignItems="center"
        >
            <Grid item xs={12} md={8}>
                <Buscador consultaTurnos={true}/>
            </Grid>
            {seleccionado&&
                <Grid item xs={12} md={8}>
                    <AfiliadoTurno autopercepcion={true} />
                </Grid>
            }            
        </Grid>
    )
}
